// VolumeService.js
// Global UI speech volume management


let uiVolume = 0.5; // Default volume (range: 0.0 - 1.0)
let volumeMaxStep = 0.1; // Default step for volume up/down

// Event listeners for volume changes
const volumeListeners = new Set();

export function getUiVolume() {
  return Math.max(0, Math.min(1, uiVolume));
}

export function setUiVolume(value) {
  let num = parseFloat(value);
  // Guard against NaN - keep current volume if invalid input
  if (isNaN(num)) {
    console.warn('⚠️ VolumeService.setUiVolume received invalid value:', value, 'keeping current volume:', uiVolume);
    return uiVolume;
  }
  uiVolume = Math.max(0, Math.min(1, num));
  notifyVolumeChanged();
  return uiVolume;
}

export function volumeUp(step) {
  // If step is not a number (e.g., ActionSystem passes context object), use default
  const stepValue = (typeof step === 'number' && !isNaN(step)) ? step : volumeMaxStep;
  
  const current = getUiVolume();
  let nextVolume = current + stepValue;
  
  // Validate nextVolume is a valid number
  if (isNaN(nextVolume)) {
    console.error('⚠️ VolumeService.volumeUp: nextVolume is NaN! current:', current, 'step:', stepValue);
    return; // Don't update if we get NaN
  }
  
  if (nextVolume >= 1.0) {
    uiVolume = 1.0;
  } else {
    uiVolume = nextVolume;
  }
  notifyVolumeChanged();
}

export function volumeDown(step) {
  // If step is not a number (e.g., ActionSystem passes context object), use default
  const stepValue = (typeof step === 'number' && !isNaN(step)) ? step : volumeMaxStep;
  
  const current = getUiVolume();
  let nextVolume = current - stepValue;
  
  // Validate nextVolume is a valid number
  if (isNaN(nextVolume)) {
    console.error('⚠️ VolumeService.volumeDown: nextVolume is NaN! current:', current, 'step:', stepValue);
    return; // Don't update if we get NaN
  }
  
  if (nextVolume <= 0.0) {
    uiVolume = 0.0;
  } else {
    uiVolume = nextVolume;
  }
  notifyVolumeChanged();
}

export function getVolumeMaxStep() {
  return volumeMaxStep;
}

export function getVolumeUpNextValue() {
  let nextVolume = getUiVolume() + volumeMaxStep;
  if (nextVolume >= 1.0) {
    return 1.0;
  } else {
    return nextVolume;
  }
}

export function getVolumeDownNextValue() {
  let nextVolume = getUiVolume() - volumeMaxStep;
  if (nextVolume <= 0.0) {
    return 0.0;
  } else {
    return nextVolume;
  }
}

// Subscribe to volume changes
export function onVolumeChanged(callback) {
  if (typeof callback === 'function') {
    volumeListeners.add(callback);
  }
  // Return unsubscribe function
  return () => {
    volumeListeners.delete(callback);
  };
}

// Notify all listeners of volume change
function notifyVolumeChanged() {
  for (const cb of volumeListeners) {
    try {
      cb(uiVolume);
    } catch (e) {
      // Ignore listener errors
    }
  }
}